import React from 'react';
import { Label } from '../../../components/ui/label';
import styles from './SettingToggle.module.css';

interface SettingToggleProps {
  id: string;
  label: string;
  description: string;
  checked: boolean;
  onChange: (enabled: boolean) => void;
}

export const SettingToggle: React.FC<SettingToggleProps> = ({
  id,
  label,
  description,
  checked,
  onChange,
}) => {
  return (
    <div className={styles.settingToggle}>
      <div className={styles.content}>
        <Label htmlFor={id} className={styles.label}>
          {label}
        </Label>
        <p className={styles.description}>{description}</p>
      </div>
      <div className={styles.control}>
        <input
          id={id}
          type="checkbox"
          checked={checked}
          onChange={e => onChange(e.target.checked)}
          className={styles.checkbox}
        />
      </div>
    </div>
  );
};
